<mat-dialog-content class="mat-typography">
	<div class="row row-no-padding mx-2">
		<div class="col-4 px-2">
			<h3 class="py-2">Dane Organizacji</h3>
			<div class="py-3">
				<mat-slide-toggle [(ngModel)]="service.organizationData.isOskar">
					Należy do grupy oskar?
				</mat-slide-toggle>
			</div>
			<mat-form-field class="w-100 mb-1">
				<input
					matInput
					type="text"
					id="shortName"
					name="shortName"
					required
					[(ngModel)]="service.organizationData.shortName"
					placeholder="Krótka nazwa"
				/>
				<mat-hint [ngStyle]="{ color: 'red' }" *ngIf="errors.shortName">* Uzupełnij wymagane pole</mat-hint>
			</mat-form-field>
			<mat-form-field class="w-100 mb-1">
				<input
					matInput
					type="text"
					id="fullName"
					name="fullName"
					required
					[(ngModel)]="service.organizationData.name"
					placeholder="Pełna nazwa"
				/>
				<mat-hint [ngStyle]="{ color: 'red' }" *ngIf="errors.name">* Uzupełnij wymagane pole</mat-hint>
			</mat-form-field>

			<mat-form-field class="w-100 mb-1">
				<input
					matInput
					type="text"
					id="regon"
					name="regon"
					required
					maxlength="14"
					[(ngModel)]="service.organizationData.regon"
					placeholder="REGON"
				/>
				<mat-hint [ngStyle]="{ color: 'red' }" *ngIf="errors.regon">* Uzupełnij wymagane pole</mat-hint>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="nip"
					name="nip"
					maxlength="15"
					[(ngModel)]="service.organizationData.nip"
					placeholder="NIP"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="krs"
					name="krs"
					maxlength="10"
					[(ngModel)]="service.organizationData.krs"
					placeholder="KRS"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="number"
					id="navigatorId"
					name="navigatorId"
					[(ngModel)]="service.organizationData.nawigatorID"
					placeholder="ID Nawigatora"
				/>
			</mat-form-field>

			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="merlinxCode"
					name="merlinxCode"
					[(ngModel)]="service.organizationData.codeMerlinx"
					placeholder="Kod MerlinX"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<mat-select
					id="organizationType"
					name="organisaionType"
					[(ngModel)]="service.organizationData.sellCategory"
					placeholder="Kategoria sprzedaży"
				>
					<mat-option [value]="item.id" *ngFor="let item of service.enterpriseData.sellCategory"
						>{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="w-100">
				<mat-select
					id="organizationCoop"
					name="organizationCoop"
					placeholder="Rodzaj współpracy"
					[(ngModel)]="service.organizationData.kindCooperation"
				>
					<mat-option [value]="item.key" *ngFor="let item of cooperationSet">{{ item.value }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="col-8 px-4 d-flex flex-column justify-content-between">
			<div>
				<div class="d-flex justify-content-between flex-row my-2">
					<h3>Adresy firmowe:</h3>
				</div>
				<div class="table-container">
					<mat-table #dataTableAddress [dataSource]="matDataAddress">
						<ng-container matColumnDef="location">
							<mat-header-cell *matHeaderCellDef> Miasto </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{ element.location?.name }} &nbsp;
								<small> ({{ element.location?.parentLocation?.name }}) </small>
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="kind">
							<mat-header-cell *matHeaderCellDef> Typ </mat-header-cell>
							<mat-cell *matCellDef="let element">{{ element.kind }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="zipCode">
							<mat-header-cell *matHeaderCellDef> Kod pocztowy </mat-header-cell>
							<mat-cell *matCellDef="let element">{{ element.zipCode }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="address">
							<mat-header-cell *matHeaderCellDef> Adres </mat-header-cell>
							<mat-cell *matCellDef="let element">{{ element.address }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="edit">
							<mat-header-cell *matHeaderCellDef> </mat-header-cell>
						</ng-container>
						<mat-header-row *matHeaderRowDef="addressColumns; sticky: true"></mat-header-row>
						<mat-row *matRowDef="let row; columns: addressColumns"></mat-row>
					</mat-table>
				</div>
			</div>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button mat-dialog-close color="warn" (click)="service.resetData()">Anuluj</button>
	<button mat-raised-button color="accent" (click)="submitOrganization()" class="me-3">Zapisz</button>
</mat-dialog-actions>
